// Design System Utilities
import { colors } from '../constants/colors'

/**
 * Utility functions untuk design system
 */

// Button variants
export const buttonVariants = {
  primary: 'px-6 py-2 bg-brand-primary text-text-primary hover:bg-brand-secondary rounded-lg font-medium transition-colors disabled:opacity-50',
  secondary: 'px-6 py-2 bg-bg-quaternary text-text-primary hover:bg-state-hover rounded-lg font-medium transition-colors disabled:opacity-50',
  ghost: 'px-6 py-2 text-text-primary hover:bg-bg-quaternary rounded-lg font-medium transition-colors disabled:opacity-50'
}

// Card variants
export const cardVariants = {
  primary: 'bg-bg-tertiary border border-border-primary rounded-xl',
  secondary: 'bg-bg-quaternary border border-border-primary rounded-xl',
  elevated: 'bg-bg-tertiary border border-border-primary rounded-xl shadow-lg'
}

// Text variants
export const textVariants = {
  heading: 'text-text-primary font-semibold',
  body: 'text-text-secondary',
  caption: 'text-text-tertiary text-sm',
  placeholder: 'text-text-placeholder'
}

// Icon button variants
export const iconButtonVariants = {
  primary: 'p-2 text-text-tertiary hover:text-text-primary hover:bg-bg-quaternary rounded-lg transition-colors',
  active: 'p-2 bg-brand-primary text-text-primary rounded-lg',
  ghost: 'p-2 text-text-tertiary hover:text-text-primary transition-colors'
}

// Input variants
export const inputVariants = {
  primary: 'bg-bg-tertiary border border-border-primary text-text-primary placeholder-text-placeholder focus:outline-none focus:ring-2 focus:ring-brand-primary rounded-lg px-4 py-2'
}

/**
 * Utility function untuk menggabungkan class names
 */
export const cn = (...classes) => {
  return classes.filter(Boolean).join(' ')
}

/**
 * Utility function untuk mendapatkan warna dari design system
 */
export const getColor = (category, variant) => {
  return colors[category]?.[variant] || '#000000'
}

/**
 * Utility function untuk membuat CSS variables
 */
export const createCSSVariables = (colorObj, prefix = '--color') => {
  const variables = {}
  
  Object.entries(colorObj).forEach(([category, variants]) => {
    if (typeof variants === 'object') {
      Object.entries(variants).forEach(([variant, value]) => {
        variables[`${prefix}-${category}-${variant}`] = value
      })
    } else {
      variables[`${prefix}-${category}`] = variants
    }
  })
  
  return variables
}

/**
 * Predefined component classes untuk konsistensi
 */
export const componentClasses = {
  // Layout
  container: 'bg-bg-primary min-h-screen',
  sidebar: 'bg-bg-secondary border-r border-border-primary',
  main: 'bg-bg-primary flex-1',
  
  // Navigation
  navItem: 'w-10 h-10 rounded-lg flex items-center justify-center transition-colors',
  navItemActive: 'w-10 h-10 rounded-lg flex items-center justify-center bg-brand-primary text-text-primary',
  navItemInactive: 'w-10 h-10 rounded-lg flex items-center justify-center text-text-tertiary hover:bg-bg-quaternary',
  
  // Forms
  textarea: 'flex-1 bg-transparent text-text-primary placeholder-text-placeholder focus:outline-none focus:ring-0 focus:border-none text-lg resize-none transition-all duration-300 ease-in-out min-h-[28px] max-h-32 overflow-y-hidden caret-white border-none outline-none shadow-none',
  
  // Cards
  suggestionCard: 'flex items-center space-x-3 p-4 text-left hover:opacity-80 rounded-xl transition-colors bg-bg-tertiary hover:bg-state-hover',
  
  // Images
  logo: 'h-16 mb-4',
  uploadedImage: 'w-32 h-32 object-cover rounded-lg border-2 border-border-primary'
}